import Fonts, { family } from 'components/base-ui/Fonts'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.white};
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 4px 8px;
  border-bottom: 1px dashed ${({ theme }) => theme.colors.lightGrey};
`

const Avatar = styled.img`
  border-radius: 50%;
  width: 28px;
  height: 28px;
`

const UserInfo = styled.div`
  flex-grow: 1;
  padding-left: 8px;
`

const MembershipCard = styled.img`
  height: 50px;
  width: 78px;
  border-radius: 4px;
`

const Name = styled(Fonts.BaseBold)`
  font-family: ${family.brand};
`

const Tier = styled(Fonts.SmallTitleRegular)`
  color: ${({ theme }) => theme.colors.darkGrey};
`

const Footer = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;
  padding: 8px;
`

export { Wrapper, Header, Avatar, UserInfo, MembershipCard, Name, Tier, Footer }
